/* eslint-disable no-undef */
const pages = [
  // BLOG and Resources
  {
    matchPath: '/:lang?/blog',
    languages: ['en-US', 'de', 'ja'],
    includeInChina: false,
  },
  {
    matchPath: '/:lang?/blog/category/:uid',
    getLanguageFromPath: true,
    exclude: ['zh-CN', 'es'],
  },
  {
    matchPath: '/:lang?/(.*)blog-(.*)',
    getLanguageFromPath: true,
    exclude: ['zh-CN', 'es'],
  },
  {
    matchPath: '/:lang?/blog/search',
    languages: ['en-US'],
    includeInChina: false,
  },
  {
    matchPath: '/:lang?/resources',
    languages: ['en-US'],
    includeInChina: false,
  },
  {
    matchPath: '/:lang?/resources/:uid',
    languages: ['en-US'],
    includeInChina: false,
  },
  {
    matchPath: '/:lang?/resources/guides/:uid',
    languages: ['en-US'],
    includeInChina: false,
  },
  {
    matchPath: '/:lang?/resources/reports/:uid',
    languages: ['en-US'],
    includeInChina: false,
  },
  {
    matchPath: '/:lang?/video',
    languages: ['en-US'],
    includeInChina: false,
  },
  {
    matchPath: '/:lang?/video/:uid',
    languages: ['en-US'],
    includeInChina: false,
  },
  // Landing pages and Merge
  {
    matchPath: '/:lang?/sellics-joins-perpetua',
    languages: ['en-US', 'de'],
    includeInChina: false,
  },
  {
    matchPath: '/:lang?/amazon-seo-tool',
    languages: ['en-US', 'de'],
    includeInChina: false,
  },
  {
    matchPath: '/:lang?/amazon-ppc-software-sponsored-ads-management-tool',
    languages: ['en-US', 'de'],
    includeInChina: false,
  },
  {
    matchPath: '/:lang?/sonar-amazon-keyword-tool',
    languages: ['en-US', 'de'],
    includeInChina: false,
  },
  {
    matchPath: '/:lang?/amazon-advertising-benchmark-tool',
    languages: ['en-US', 'de'],
    includeInChina: false,
  },
  {
    matchPath: '/:lang?/impressum',
    languages: ['de'],
    includeInChina: false,
  },
  {
    matchPath: '/:lang?/amazon-accelerator-program',
    languages: ['en-US', 'ja'],
    includeInChina: false,
  },
  {
    matchPath: '/:lang?/webinars',
    languages: ['en-US'],
    includeInChina: false,
  },
  {
    matchPath: '/:lang?/webinars/:uid',
    languages: ['en-US'],
    includeInChina: false,
  },
  {
    matchPath: '/:lang?/amazon-incremental-growth',
    languages: ['en-US'],
  },
  {
    matchPath: '/:lang?/brand-and-media',
    languages: ['en-US'],
    includeInChina: false,
  },
  {
    matchPath: '/:lang?/amazon-amc-audiences',
    languages: ['en-US'],
    includeInChina: false,
  },
  {
    matchPath: '/:lang?/careers',
    languages: ['en-US'],
    includeInChina: false,
  },
  {
    matchPath: '/:lang?/perpetua-for-startups',
    languages: ['en-US'],
    includeInChina: false,
  },
  {
    matchPath: '/:lang?/the-loop-newsletter',
    languages: ['en-US'],
    includeInChina: false,
  },
  // Product
  {
    matchPath: '/:lang?/prism-amazon-market-share-tool',
    languages: ['en-US', 'de', 'ja'],
    includeInChina: false,
  },
  {
    matchPath: '/:lang?/amazon-advertising-software',
    languages: ['en-US', 'de', 'ja', 'es'],
    includeInChina: true,
  },
  {
    matchPath: '/:lang?/instacart-advertising-software',
    languages: ['en-US', 'de', 'ja', 'es'],
    includeInChina: true,
  },
  {
    matchPath: '/:lang?/walmart-advertising-software',
    languages: ['en-US', 'de', 'ja', 'es'],
    includeInChina: true,
  },
  // Solutions
  {
    matchPath: '/:lang?/amazon-demand-side-platform-managed-service',
    languages: ['en-US', 'de', 'ja', 'es'],
    includeInChina: true,
  },
  {
    matchPath: '/:lang?/amazon-demand-side-platform-self-service',
    languages: ['en-US'],
    includeInChina: false,
  },
  {
    matchPath: '/:lang?/ecommerce-business-intelligence',
    languages: ['en-US', 'de', 'ja', 'es'],
    includeInChina: true,
  },
  {
    matchPath: '/:lang?/amc-amazon-marketing-cloud',
    languages: ['en-US', 'de', 'ja', 'es'],
    includeInChina: false,
  },
  {
    matchPath: '/:lang?/amazon-ppc-software',
    languages: ['en-US'],
    includeInChina: false,
  },
  // Other and company
  {
    matchPath: '/:lang?/agencies',
    languages: ['en-US', 'de', 'ja', 'es'],
    includeInChina: true,
  },
  {
    matchPath: '/:lang?/pricing',
    languages: ['en-US', 'de', 'ja', 'es'],
    includeInChina: true,
  },
  {
    matchPath: '/:lang?/about-us',
    languages: ['en-US', 'de', 'ja', 'es'],
    includeInChina: true,
  },
  {
    matchPath: '/:lang?/cookie-policy',
    languages: ['en-US', 'de', 'ja', 'es'],
    includeInChina: true,
  },
  {
    matchPath: '/:lang?/tos',
    languages: ['en-US', 'de', 'ja', 'es'],
    includeInChina: true,
  },
  {
    matchPath: '/:lang?/privacy',
    languages: ['en-US', 'de', 'ja', 'es'],
    includeInChina: true,
  },
  {
    matchPath: '/:lang?/cookie-policy',
    languages: ['en-US', 'de', 'ja', 'es'],
    includeInChina: false,
  },
  // Conversion
  {
    matchPath: '/:lang?/demo',
    languages: ['en-US', 'de', 'ja', 'es'],
    includeInChina: true,
  },
  // GLOBAL RULING BELONGS AT BOTTOM
  {
    matchPath: '/',
    languages: ['en-US', 'de', 'ja', 'es'],
    includeInChina: true,
  },
  {
    matchPath: '/:lang?/:uid',
    languages: ['en-US'],
    includeInChina: false,
  },
];

function getPages(isChinaSite) {
  return pages
    .map(page => {
      let {
        matchPath,
        languages,
        exclude,
        getLanguageFromPath,
        includeInChina,
      } = page;

      if (isChinaSite) {
        if (includeInChina) {
          languages = ['zh-CN'];
        } else {
          return null;
        }
      }

      const pageConfig = {
        matchPath,
        languages,
        exclude,
        getLanguageFromPath,
      };

      // Remove properties that are not needed
      Object.keys(pageConfig).forEach(key => {
        if (
          key !== 'matchPath' &&
          key !== 'languages' &&
          key !== 'exclude' &&
          key !== 'getLanguageFromPath'
        ) {
          delete pageConfig[key];
        }
      });

      return pageConfig;
    })
    .filter(page => page !== null); // Filter out null values
}

module.exports = {
  getPages,
  pages,
};
